import { useSelector } from "react-redux";

import { Modal } from "@/components/modal/modal";
import { Button, FormSize } from "ui/ecosystems/forms";
import { FBPageExtended } from "api/social-account-connect/facebook";

import { NeedHelpButton } from "../need-help-button";
import { FacebookPageList } from "../facebook-page-list";
import { addFacebookPageAccountFx } from "./model";
import { getConnectButtonStateFactory } from "../connect-button";
import { PlatformTypes } from "features/post";
import { selectSocialConnectFacebookPageState } from "../../redux-model";

interface FacebookPageConnectDialogProps {
  show: boolean;
  onHide(): void;
  onBack(): void;
  isAlreadyAdded(acc: FBPageExtended): boolean;
}

export function FacebookPageConnectDialog({
  show,
  onHide,
  onBack,
  isAlreadyAdded,
}: FacebookPageConnectDialogProps) {
  const { data, connectingFacebookPageId } = useSelector(
    selectSocialConnectFacebookPageState
  );

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title>Facebook Page connection</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FacebookPageList
          pages={data?.pages ?? []}
          onConnect={(page) => {
            if (data) {
              addFacebookPageAccountFx({
                session: data.session,
                account: data.account,
                page,
              });
            }
          }}
          getConnectButtonState={getConnectButtonStateFactory({
            isConnected: isAlreadyAdded,
            isConnecting: (page) => page.id === connectingFacebookPageId,
            isDisabled: () => Boolean(connectingFacebookPageId),
          })}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button text size={FormSize.large} onClick={onBack}>
          Back
        </Button>
        <NeedHelpButton
          platform={PlatformTypes.facebook}
          chatQuery="accounts"
        />
      </Modal.Footer>
    </Modal>
  );
}
